module.exports = __webpack_public_path__ + "img/Social-ecological transformation in cities in Asia.d0c51fed.png";